import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class LaborManagement_ds_assigned_task_operation_codes_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { warehouseIds?: number[], workClassIds?: number[], fromDate?: string, toDate?: string, projectId?: number, ownerId?: number, fullTextSearch?: string }): 
  Promise<{ result: { OperationCodeId?: number, OperationCode?: { Name?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/LaborManagement/datasources/ds_assigned_task_operation_codes_dd/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { warehouseIds?: number[], workClassIds?: number[], fromDate?: string, toDate?: string, projectId?: number, ownerId?: number, fullTextSearch?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { OperationCodeId?: number, OperationCode?: { Name?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/LaborManagement/datasources/ds_assigned_task_operation_codes_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { warehouseIds?: number[], workClassIds?: number[], fromDate?: string, toDate?: string, projectId?: number, ownerId?: number, fullTextSearch?: string, $keys: { OperationCode?: { Name?: string }, OperationCodeId?: number }[] }): 
  Promise<{ result: { OperationCodeId?: number, OperationCode?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/LaborManagement/datasources/ds_assigned_task_operation_codes_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      warehouseIds?: number[], workClassIds?: number[], fromDate?: string, toDate?: string, projectId?: number, ownerId?: number, fullTextSearch?: string    }) {
      return false;
    }
}
